<template>
	<div>
		<div class="linkModule">
			<div class="moduleBox">
				<div class="linkContent flex flex-pack-justify">
					<div class="left flex">
						<div class="linkBox" v-for="(item,index) in link" :key='index'>
							<div class="linkTitle" @click="link2url(item.url)">{{item.title}}</div>
							<div class="linkList">
								<a @click="link2url(vo.url)" v-for="(vo,k) in item.list" :key='k'>{{vo.name}}</a>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="lxtel">3067657284@qq.com</div>
						<div class="workTime">工作时间：工作日9: 00-18: 00</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			杭州飞长好旅游有限公司  版权所有 | 
			<a
              href="http://beian.miit.gov.cn"
              target="_blank"
            >
              备案号:浙ICP备2024111927号-1
            </a>
		</div>
	</div>
</template>

<script>
	export default {
		components:{
		},
		data() {
			return {
				link:[
					{
						title:'用户协议',
						url:'/service',
						list:[
							
						]
					},
					{
						title:'关于我们',
						url:'/about',
						list:[
						]
					}
				]
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods: {
			kefuShow(){
				this.$refs.kefu.setShow();
			},
			link2url(url){
				if(url){
					this.$router.push({path:url})
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.linkModule{
		width: 100%;
		background: #F5F7FB;
		.linkContent{
			width: 100%;
			padding: 80px 0;
			.left{
				width: calc(100% - 200px);
				.linkBox{
					width: 260px;
					.linkTitle{
						width: 100%;
						font-size: 16px;
						color: #333333;
						line-height: 19px;
						cursor: pointer;
					}
					.linkList{
						width: 100%;
						margin-top: 24px;
						>a{
							display: block;
							font-size: 14px;
							color: #666666;
							line-height: 28px;
							&:hover{
								text-decoration: underline;
							}
						}
					}
				}
			}
			.right{
				// width: 200px;
				.lxtel{
					width: 100%;
					font-size: 24px;
					color: #333333;
					line-height: 28px;
					font-weight: bold;
					text-align: right;
				}
				.workTime{
					width: 100%;
					margin-top: 6px;
					font-size: 14px;
					color: #333333;
					line-height: 16px;
					text-align: right;
				}
				.contact{
					width: 125px;
					height: 42px;
					background: #0A48AD;
					padding: 0 15px 0 12px;
					font-size: 12px;
					color: #FFFFFF;
					margin-top: 49px;
					>img{
						display: block;
						width: 25px;
						height: 25px;
					}
				}
			}
		}
	}
	.footer{
		width: 100%;
		height: 62px;
		background: #0A48AD;
		text-align: center;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 62px;
		>a{
			color: #FFFFFF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue